import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "document",
  "use": "document-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"document\"><path d=\"M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 1a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-3.688-5H11v-1H6v1h.313Zm1.021-4H14V8H6v1h1.333Zm0 2H14v-1H6v1h1.333Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol